import Vue from "vue";
import html2Canvas from "html2canvas";
import html2pdf from "html2pdf.js";
import { json2csv } from 'json-2-csv';
import * as Enums from "@/constants/enums.js";

Vue.mixin({
  data: function () {
    return {
      fileNameCSV: '',
      // Make enums available in data
      $enums: Enums
    }
  },
  methods: {
    removeFromArray(array, item) {
      array = array.filter(e => e !== item);
      return array;
    },
    fromGooglePlaceToAddress(place) {
      if (place === null) return {};
      var address = {};
      address.name = place.name;
      address.telephone = place.international_phone_number;
      address.web = place.website;
      address.address = place.formatted_address.split(",")[0];
      address.city = place.formatted_address
        .split(",")[1]
        .trim()
        .split(" ")[1];
      address.postalcode = place.formatted_address
        .split(",")[1]
        .trim()
        .split(" ")[0];
      return address;
    },
    ifEmptyStr(str) {
      if (str === undefined || str === null) return "";
      else return str;
    },
    ifEmptyNbr(nbr) {
      if (nbr === undefined) return 0;
      else return nbr;
    },
    printHtml2Canvas(item) {
      var element = document.getElementById(item);
      html2Canvas(element).then(canvas => {
        const base64image = canvas.toDataURL("image/png");
        this.debugBase64(base64image);
      });
    },
    debugBase64(base64URL) {
      var win = window.open();
      win.document.write(
        '<iframe src="' +
          base64URL +
          '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
      );
    },
    printHtml2Pdf(item, myfile) {
      var element = document.getElementById(item);
      var opt = {
        margin: 1,
        filename: myfile,
        image: { type: "jpg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true, allowTaint: true },
        jsPDF: {
          unit: "cm",
          format: [20, (element.clientHeight / 100) * 3],
          orientation: "portrait"
        }
      };
      html2pdf()
        .set(opt)
        .from(element)
        .save();
    },
    printHtml2PdfAsIs(item, myfile) {
      var element = document.getElementById(item);
      var opt = {
        margin: 1,
        filename: myfile,
        image: { type: "jpg", quality: 0.98 },
        //html2canvas: { scale: 1, useCORS: true, allowTaint: true },
        jsPDF: {
          unit: "cm",
          format: "a4",
          orientation: "portrait"
        }
      };
      html2pdf()
        .set(opt)
        .from(element)
        .save();
    },
    createCSV(rows, optionsCSV, filename) {
      this.fileNameCSV = filename;
      json2csv(rows, this.saveCSV, optionsCSV);
    },
    saveCSV(err, csv) {
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const e = document.createEvent("MouseEvents"),
        a = document.createElement("a");
      a.download = this.fileNameCSV;
      a.href = window.URL.createObjectURL(blob);
      a.dataset.downloadurl = ["text/csv", a.download, a.href].join(":");
      e.initEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      );
      a.dispatchEvent(e);
    }
  }
});
